<template>
	<div class="partial partial__dashboard">
		dashboard
	</div>
</template>

<script>
	export default {
		name: 'dashboardPartial'
	}
</script>

<style scoped lang="scss">
	
</style>


// WEBPACK FOOTER //
// src/views/partials/Dashboard.vue